// «إقفال الفترة» inside the accounts module (HANDOFF §3 `/accounts/close`,
// boards accounts/close--period + accounts/close--locked) and the GLOBAL
// closed-period dialog every entry point uses.
//
// Gates: flag erp.accounts; manager+ reads (HANDOFF §9 — staff never sees the
// period); close / reopen are the owner's (buttons absent for the manager;
// erp-core enforces with 403). Off ⇒ absent from menu and routes.
//
// Shell wiring (done in this item; pinned by src/app/locked-period-wiring.test.tsx):
//   1. <LockedPeriodHost/> once inside AppShell (Router + Toast + Query in scope);
//   2. makeQueryClient(): new QueryClient({ mutationCache: new MutationCache({
//        onError: handlePeriodClosedMutationError }), … })
// so a 409 `period_closed` from ANY mutation opens «فترة مقفلة». The hosts in
// the bank / close screens are fallbacks for their isolated tests; only the
// first mounted host renders, so the shell's wins in the app.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export const CLOSE_PATH = '/accounts/close';
const g = gate({ flag: 'erp.accounts', minRole: 'manager' });

export const closeRoutes: RouteObject[] = [
  { path: CLOSE_PATH, lazy: () => import('./screens/PeriodClose').then((m) => ({ Component: m.PeriodCloseRoute })), handle: g },
];

export const closeMenu: MenuItem[] = [{ key: 'close', label: 'إقفال الفترة', to: CLOSE_PATH, flag: 'erp.accounts', minRole: 'manager' }];

/** Deep link to a month's close page (`?period=YYYY-MM`). */
export const closeHref = (month: string) => `${CLOSE_PATH}?period=${month}`;

export { LockedPeriodDialog, LockedPeriodHost, usePeriodClosed, fallbackDetail } from './LockedPeriodDialog';
export { isolateCodes, isolateText } from './isolate';
export {
  handlePeriodClosedMutationError,
  isPeriodClosed,
  lockedPeriodStore,
  periodClosedOf,
  showLockedPeriod,
  PERIOD_CLOSED,
} from './locked-store';
export type { LockedPeriodOptions, LockedPeriodRequest, PeriodClosedMeta, ReversalOutcome } from './locked-store';
export type { PeriodClosedProblem } from './types';
